import { dayLabel, onDay, parseDay, timeLabel, today as todayDay } from '../../lib/calendar.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-month ---
let __fez_component_0;
{
const SHOWN = 3
__fez_component_0 = class {
  PROPS = {
    days: Array,
    day: String,
    items: Array,
    countdowns: { type: Object, default: null },
    marks: { type: Object, default: null },
    on_open: { type: Function, state: true, default: () => {} },
    on_day: { type: Function, state: true, default: () => {} },
    on_create: { type: Function, state: true, default: () => {} },
  }

  open(key) {
    this.state.on_open(key)
  }

  day(day) {
    this.state.on_day(day)
  }

  create(day) {
    this.state.on_create(day)
  }

  beforeRender() {
    const items = this.props.items || []
    const month = parseDay(this.props.day).getUTCMonth()
    const today = todayDay()
    this.state.weekdays = this.props.days.slice(0, 7).map((day) => dayLabel(day, { weekday: 'short' }))
    this.state.weeks = []
    this.props.days.forEach((day, index) => {
      if (index % 7 === 0) this.state.weeks.push({ key: day, cells: [] })
      const date = parseDay(day)
      const here = onDay(items, day).sort((a, b) => Number(b.all_day) - Number(a.all_day) || a.startAt - b.startAt)
      const mark = this.props.marks?.[day]
      this.state.weeks[this.state.weeks.length - 1].cells.push({
        day,
        num: date.getUTCDate(),
        outside: date.getUTCMonth() !== month,
        today: day === today,
        label: mark?.label || '',
        circled: Boolean(mark?.circled),
        items: here.slice(0, SHOWN).map((item) => ({
          ...item,
          time: item.all_day || item.firstDay !== day ? '' : timeLabel(item.startAt),
          block: item.all_day || item.firstDay !== item.lastDay,
        })),
        more: here.length > SHOWN ? `${here.length - SHOWN} more` : '',
        count: this.props.countdowns?.[day]?.[0] || null,
        countTitle: (this.props.countdowns?.[day] || []).map((line) => line.text).join('\n'),
      })
    })
  }

  CSS = `:fez {
display:flex;flex-direction:column;height:100%;.mo-head,.mo-week{display:grid;grid-template-columns:repeat(7,minmax(0,1fr))}.mo-head{border-bottom:1px solid var(--color-border)}.mo-dow{padding:var(--space-2);color:var(--color-text-muted);font-size:var(--text-xs);font-weight:var(--weight-semibold);letter-spacing:0.04em;text-align:center;text-transform:uppercase}.mo-grid{display:grid;flex:1;grid-auto-rows:minmax(96px,1fr);min-height:0;overflow-y:auto}.mo-week + .mo-week{border-top:1px solid var(--color-border)}.mo-cell{display:flex;flex-direction:column;gap:2px;min-width:0;padding:var(--space-1);cursor:pointer;container:mo-cell / inline-size;& + .mo-cell{border-left:1px solid var(--color-border)}&.outside{background:var(--color-bg-subtle);.mo-num{color:var(--color-text-subtle)}}}.mo-top{display:flex;align-items:center;gap:var(--space-1);min-width:0;margin:-3px;padding:3px;overflow:hidden}.mo-count{display:inline-flex;flex:0 1 auto;align-items:center;gap:3px;min-width:0;padding:0 2px;border:0;background:transparent;color:var(--color-text-muted);font:inherit;font-size:var(--text-2xs);cursor:pointer;&:hover{color:var(--color-text)}}.mo-count-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mo-label{flex:none;max-width:65%;overflow:hidden;color:var(--color-accent);font-size:var(--text-xs);font-weight:var(--weight-semibold);text-overflow:ellipsis;white-space:nowrap}.mo-num{flex:none;align-self:flex-start;min-width:26px;height:26px;padding:0 var(--space-1);border:0;border-radius:var(--radius-full);background:transparent;color:var(--color-text);font:inherit;font-size:var(--text-sm);font-weight:var(--weight-medium);cursor:pointer;&:hover{background:var(--color-bg-hover)}&.circled{outline:2px solid var(--color-danger);outline-offset:1px}}.mo-cell.today .mo-num{background:var(--color-accent);color:var(--color-accent-text)}@container mo-cell (max-width:119px){.mo-top{flex-wrap:wrap;row-gap:0}.mo-label{order:1;flex:1 1 100%;max-width:none}}.mo-item{display:flex;align-items:center;gap:var(--space-1);min-width:0;padding:1px var(--space-1);border:0;border-radius:var(--radius-sm);background:transparent;color:var(--color-text);font:inherit;font-size:var(--text-xs);text-align:left;cursor:pointer;&:hover{background:var(--color-bg-hover)}&.block{background:var(--tag);color:var(--color-text-inverse);font-weight:var(--weight-medium)}&.cancelled .mo-title{text-decoration:line-through;opacity:0.7}}.mo-dot{width:7px;height:7px;flex:none;border-radius:var(--radius-full);background:var(--tag)}.mo-time{flex:none;color:var(--color-text-muted)}.mo-title{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mo-more{align-self:flex-start;padding:0 var(--space-1);border:0;background:transparent;color:var(--color-text-muted);font:inherit;font-size:var(--text-xs);font-weight:var(--weight-medium);cursor:pointer;&:hover{color:var(--color-text)}}
}`

  HTML = `<div class="mo-head">
{#each state.weekdays as weekday}
<div class="mo-dow">{weekday}</div>
{/each}
</div>
<div class="mo-grid">
{#each state.weeks as week}
<div class="mo-week" key={week.key}>
{#each week.cells as cell}
<div class="mo-cell" class:outside={cell.outside} class:today={cell.today} onclick!="fez.create('{cell.day}')">
<div class="mo-top">
<button type="button" class="mo-num" class:circled={cell.circled} onclick="fez.day('{cell.day}')">{cell.num}</button>
{#if cell.label}<span class="mo-label" title={cell.label}>{cell.label}</span>{/if}
{#if cell.count}
<button type="button" class="mo-count" title={cell.countTitle} onclick="fez.open('{cell.count.key}')"><ui-icon name="hourglass-simple" size="11"></ui-icon><span class="mo-count-text">{cell.count.text}</span></button>
{/if}
</div>
{#each cell.items as item}
<button type="button" class="mo-item" class:block={item.block} class:cancelled={item.cancelled} style="--tag: var(--color-avatar-{item.color})" title={item.title} onclick="fez.open('{item.key}')">
{#unless item.block}<span class="mo-dot"></span>{/unless}
{#if item.time}<span class="mo-time">{item.time}</span>{/if}
<span class="mo-title">{item.title}</span>
</button>
{/each}
{#if cell.more}
<button type="button" class="mo-more" onclick="fez.day('{cell.day}')">{cell.more}</button>
{/if}
</div>
{/each}
</div>
{/each}
</div>`
};
}

Fez('calendar-month', __fez_component_0);

export default __fez_component_0;
